import React from 'react';
import './dropdown.css';
import Select from "react-select";

const NoOptionsMessage = props => {
  return (
    <div className="l-align_center">Ничего не найдено</div>
  );
};

const handleVerification = (e) => {
  var invalidSelect = document.querySelectorAll(".invalid-select");
  if (invalidSelect.length) {
    setTimeout(function(){
      invalidSelect.forEach(function(e){
        var placeholder = e.querySelector(".select__placeholder");
        if(placeholder === null) {
          e.classList.remove("invalid-select");
          e.nextSibling.innerHTML = '';
        }
      });
    }, 100)
  }
}

const Dropdown = props => {
  return(
    <div>
      <div className="dropdown_label">{props.label}</div>
      <div className="dropdown_select" data-required={props.required}>
        <Select onChange={props.onChange}
                menuPlacement="auto"
                components={{ NoOptionsMessage }} onMenuClose={handleVerification}
                options={props.items} required={props.required} isDisabled={props.disabled}
                className="select" isMulti={props.isMulti} classNamePrefix="select" name={props.name}
                placeholder={props.placeholder} defaultValue={props.defaultValue} />
      </div>
      <div className="dropdown_underinput">{props.underinput}</div>
    </div>
  )
}

export default Dropdown;